import { Component, type ReactNode } from 'react';
import { Alert } from 'antd';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }
  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <Alert
          type="error"
          showIcon
          message="Something broke"
          description={this.state.error.message}
          style={{ margin: 24 }}
        />
      );
    }
    return this.props.children;
  }
}
